import {
  collection, getDocs, query, where, getCountFromServer,
} from 'firebase/firestore';

import { db } from '@/config/firebase';

class RequestService {
  static async getAll(): Promise<any[]> {
    const querySnapshot = await getDocs(query(collection(db, 'requests')));
    const requests: any[] = [];
    let index = 1;

    querySnapshot.forEach((doc: any) => {
      // eslint-disable-next-line no-plusplus
      requests.push({ id: index++, ...doc.data() });
    });
    return requests;
  }

  static async getMonthlyBreakdown() {
    const requests = await this.getAll();

    const breakdown: Record<string, number> = {};

    requests.forEach((request: any) => {
      if (request.createdAt) {
        const date = request.createdAt.toDate();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Jan = 0
        const key = `${year}-${month}`;

        if (breakdown[key]) {
          breakdown[key] += 1;
        } else {
          breakdown[key] = 1;
        }
      }
    });

    console.log('Monthly Breakdown:', breakdown);
    return breakdown;
  }

  static async getRequestsByUserIds(userIds: string[]): Promise<any[]> {
    if (!userIds.length) return [];
    const requestsRef = collection(db, 'requests');
    // Firestore 'in' queries are limited to 10 items per query
    const chunkSize = 10;
    const chunks: string[][] = [];
    for (let i = 0; i < userIds.length; i += chunkSize) {
      chunks.push(userIds.slice(i, i + chunkSize));
    }
    const querySnapshots = await Promise.all(
      chunks.map((chunk) => {
        const q = query(requestsRef, where('userId', 'in', chunk));
        return getDocs(q);
      }),
    );
    const allRequests: any[] = [];
    querySnapshots.forEach((querySnapshot) => {
      querySnapshot.forEach((doc: any) => {
        allRequests.push({ id: doc.id, ...doc.data() });
      });
    });
    return allRequests;
  }

  static async getRequestsCount(): Promise<number> {
    const countSnap = await getCountFromServer(collection(db, 'requests'));
    return countSnap.data().count;
  }

  static async getPaidRequestsCount(): Promise<number> {
    const countSnap = await getCountFromServer(query(collection(db, 'requests'), where('status', '==', 3)));
    return countSnap.data().count;
  }

  /**
   * Returns requests for given userIds along with a derived boolean isPaid.
   */
  static async getRequestsByUserIdsWithDerived(userIds: string[]): Promise<any[]> {
    const reqs: any[] = await this.getRequestsByUserIds(userIds);
    return reqs.map((r: any) => ({
      ...r,
      isPaid: r.status === 'paid' || r.status === 3 || r.status === 'completed',
    }));
  }
}

export default RequestService;
